export enum UserType {
  ADMIN = 'ADMIN',
  LOCAL = 'LOCAL',
  DIRECTORY = 'DIRECTORY',
  PRECEDENT = 'PRECEDENT',
  PRECEDENT_REVIEWER = 'PRECEDENT_REVIEWER'
}
